import { Link, useLocation } from 'react-router-dom';
import { LayoutGrid, Settings, MapPin, Trophy } from 'lucide-react';

import { Button } from '@/components/ui/button';

const AppSidebar = () => {
  const location = useLocation();

  return (
    <div className="h-full fixed left-0 top-0 bottom-0 w-[var(--sidebar-width)] border-r px-4 pt-[var(--sidebar-padding-top)] bg-background">
      <div className="flex flex-col gap-2">
        <Button
          className="w-full justify-start"
          variant={location.pathname === '/' ? 'secondary' : 'ghost'}
          asChild
        >
          <Link component={Link} to="/">
            <LayoutGrid />
            Dashboard
          </Link>
        </Button>
        <Button
          className="w-full justify-start"
          variant={
            location.pathname.startsWith('/coach') ? 'secondary' : 'ghost'
          }
          asChild
        >
          <Link component={Link} to="/coach">
            <Trophy />
            Coaches
          </Link>
        </Button>
        <Button
          className="w-full justify-start"
          variant={
            location.pathname.startsWith('/location') ? 'secondary' : 'ghost'
          }
          asChild
        >
          <Link component={Link} to="/location">
            <MapPin />
            Locations
          </Link>
        </Button>
        <Button
          className="w-full justify-start"
          variant={
            location.pathname.startsWith('/setting') ? 'secondary' : 'ghost'
          }
          asChild
        >
          <Link component={Link} to="/setting">
            <Settings />
            Settings
          </Link>
        </Button>
      </div>
    </div>
  );
};

export default AppSidebar;
